// Browse collections carousel: prev/next arrows and the scroll progress bar.
//
// The track is a native overflow-x scroller with scroll-snap, so touch and
// trackpad scrolling work with no JS at all — this only adds the arrow
// controls and the progress indicator on top.

function initBrowseCollections(root) {
  if (root.dataset.bcInit) return;
  root.dataset.bcInit = '1';

  const track = root.querySelector('[data-bc-track]');
  if (!track) return;

  const prev = root.querySelector('[data-bc-prev]');
  const next = root.querySelector('[data-bc-next]');
  const thumb = root.querySelector('[data-bc-thumb]');

  let ticking = false;

  function step() {
    const item = track.querySelector('.browse-collections__item');
    if (!item) return track.clientWidth;

    const gap = parseFloat(getComputedStyle(track).columnGap || '0') || 0;
    return item.getBoundingClientRect().width + gap;
  }

  function update() {
    ticking = false;

    const max = track.scrollWidth - track.clientWidth;
    // Sub-pixel rounding means scrollLeft rarely lands exactly on max.
    const atStart = track.scrollLeft <= 1;
    const atEnd = track.scrollLeft >= max - 1;

    if (prev) prev.disabled = atStart;
    if (next) next.disabled = atEnd;

    if (thumb) {
      const ratio = track.scrollWidth > 0 ? track.clientWidth / track.scrollWidth : 1;
      thumb.style.width = Math.min(ratio * 100, 100) + '%';
      thumb.style.insetInlineStart = (track.scrollLeft / track.scrollWidth) * 100 + '%';
    }
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }

  prev?.addEventListener('click', function () {
    track.scrollBy({ left: -step(), behavior: 'smooth' });
  });

  next?.addEventListener('click', function () {
    track.scrollBy({ left: step(), behavior: 'smooth' });
  });

  track.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  update();
}

function bootBrowseCollections(scope) {
  (scope || document).querySelectorAll('[data-browse-collections]').forEach(initBrowseCollections);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    bootBrowseCollections();
  });
} else {
  bootBrowseCollections();
}

document.addEventListener('shopify:section:load', function (e) {
  bootBrowseCollections(e.target);
});
